import { render, staticRenderFns } from "./UserContactDetails.vue?vue&type=template&id=3f147754&scoped=true&"
import script from "./UserContactDetails.vue?vue&type=script&lang=js&"
export * from "./UserContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserContactDetails.vue?vue&type=style&index=0&id=3f147754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f147754",
  null
  
)

export default component.exports